import { Link } from 'gatsby';
import React from 'react';

export const Logo = () => {
  return <Link to='/'>Crush Them All Fans</Link>;
};
